export const upsell = {
  alt: {
    sunrise: "Illustration of a sunrise",
  },
  cta: {
    learnMore: "Learn more",
    upgrade: "Upgrade now",
  },
  crewAndProgram: {
    description:
      "Conceive Premium includes expert-led live programming from the comfort of your home. You’ll be matched with a crew of 6-10 peers on the same journey as you. Upgrade to Premium to start your program today.",
  },
  moreSupport: {
    cta: "Learn More",
    description:
      "With Conceive Premium you get a dedicated fertility coach that you can call or FaceTime with (in addition to 24/7 messaging), live sessions with your crew, a personalized fertility plan to take to your medical team, and 1:1 fertility finance coaching with a financial coordinator.",
    heading: "Get more support with Conceive Premium",
  },
};
